import { createActions } from 'redux-actions';

import { API } from '@service';
import { actionTypes } from './actionTypes';
// import { validateLogin, clearTokens } from '@utils/common';
import { USER_ROLE_MODEL } from '@model';
import commonActions from './common';
import PendoIO from '@utils/pendo';
import _ from 'lodash';
import { resetChatbotWsSession } from '../../aiChat/ws/chatbotWsScope';
import { clearActiveSessions } from './activeSessions';
const {
  login: {
    SAVE_USER_INFO,
    DELETE_USER_INFO,
    ACCEPT_TERMS,
    ACCEPT_NEW_TERMS,
    UPDATE_USER_INFO,
    CHANGE_SESSION_TIMEOUT,
  },
} = actionTypes;

const loginActions = createActions(
  {},
  SAVE_USER_INFO,
  DELETE_USER_INFO,
  ACCEPT_TERMS,
  ACCEPT_NEW_TERMS,
  UPDATE_USER_INFO,
  CHANGE_SESSION_TIMEOUT,
);

const getTermsAcceptance = () => async (dispatch, getState) => {
  const uid = getState().login.userInfo?.uid;
  if (!uid) {
    return undefined;
  }

  dispatch(commonActions.changeLoading(true));
  try {
    const hasAcceptedTerms = await API.getTermsAreAccepted(uid);
    if (typeof hasAcceptedTerms === 'boolean') {
      dispatch(loginActions.acceptTerms(hasAcceptedTerms));
      return hasAcceptedTerms;
    }
    return undefined;
  } finally {
    dispatch(commonActions.changeLoading(false));
  }
};

const getNewTermsAcceptance = () => async (dispatch, getState) => {
  const uid = getState().login.userInfo?.uid;
  if (!uid) {
    return undefined;
  }

  dispatch(commonActions.changeLoading(true));
  try {
    const hasAcceptedNewTerms = await API.getNewTermsAreAccepted(uid);
    if (typeof hasAcceptedNewTerms === 'boolean') {
      dispatch(loginActions.acceptNewTerms(hasAcceptedNewTerms));
      return hasAcceptedNewTerms;
    }
    return undefined;
  } finally {
    dispatch(commonActions.changeLoading(false));
  }
};

const login = (type) => async (dispatch) => {
  window.localStorage.setItem('type', type);

  let redirectUrl = '';

  if (type === 'identity') {
    redirectUrl = `${process.env.REACT_APP_NEW_LOGIN_AUTH_URL}/auth//v1/login?sso=openam&state=${process.env.REACT_APP_state}&redirect=${process.env.REACT_APP_NEW_LOGIN_REDIRECT_URL}`;
  } else {
    redirectUrl = `${process.env.REACT_APP_NEW_LOGIN_AUTH_URL}/auth//v1/login?sso=iam&state=${process.env.REACT_APP_IAM_RESPONSE_TYPE}&redirect=${process.env.REACT_APP_NEW_LOGIN_REDIRECT_URL}`;
  }

  window.location.replace(redirectUrl);
};

const getUserRole = (userInfo = {}) => {
  let role = USER_ROLE_MODEL.INTERNAL;

  if (userInfo?.isAdmin) {
    role = USER_ROLE_MODEL.ADMIN;
  } else if (userInfo?.isClient) {
    role = USER_ROLE_MODEL.CLIENT;
  }

  return role;
};

const logout = () => async (dispatch, getState) => {
  await API.logoutFromCommonService().finally(() => {
    resetChatbotWsSession();
    dispatch(clearActiveSessions());
    window.localStorage.clear();
    window.sessionStorage.clear();
    // if (isClient) {
    //   window.location.replace(`${process.env.REACT_APP_IAM_LOGOUT_URI}`);
    // } else {
    dispatch(loginActions.deleteUserInfo({}));
    // }
  });
};

const register = (params) => async (dispatch, getState) => {
  dispatch(commonActions.changeLoading(true));

  try {
    const res = await API.registerIAMUser(params);

    if (res?.token) {
      window.localStorage.setItem('accessToken', res.token);
      window.localStorage.setItem('refreshToken', res.refresh_token);

      await getUserInfo(dispatch, getState);
      dispatch(commonActions.changeLoading(false));

      return '200'; // Return success code
    } else {
      dispatch(commonActions.changeLoading(false));
      return '400'; // Return error code
    }
  } catch (error) {
    console.error('Registration error:', error);
    dispatch(commonActions.changeLoading(false));
    return '500'; // Return error code
  }
};

const fetchUserDetails = (activationId) => async (dispatch, getState) => {
  const id =
    typeof activationId === 'string'
      ? activationId.trim()
      : String(activationId || '').trim();
  if (!id || id === 'undefined' || id === 'null') {
    return null;
  }
  dispatch(commonActions.changeLoading(true));
  try {
    return await API.fetchUserDetails(activationId);
  } finally {
    dispatch(commonActions.changeLoading(false));
  }
};

// const getMoreUserInfo = (userInfo) => async (dispatch, getState) => {
//   const userInfoInprops = getState().login.userInfo;
//   if (!userInfo) {
//     return;
//   }

//   const { uid } = userInfo;
//   const additionalUserInfo = (
//     await API.queryMemberInfoByGuid(uid)
//   )?.members.find((m) => m.guid === uid);
//   dispatch(
//     loginActions.saveUserInfo(
//       Object.assign({}, userInfo, userInfoInprops, additionalUserInfo),
//     ),
//   );
// };

const getLogin = (p) => async (dispatch, getState) => {
  try {
    const res = await API.reqToken(p);

    if (res && res.token) {
      window.Storage.setItem('accessToken', res.token);
      window.Storage.setItem('refreshToken', res.refresh_token);

      await getUserInfo(dispatch, getState);

      return true;
    } else {
      console.error('=== No Token in Response ===');
      console.error('Response was:', res);
      return false;
    }
  } catch (error) {
    console.error('=== getLogin ERROR ===');
    console.error('Error:', error);
    throw error;
  }
};

const getUserInfo = async (dispatch, getState) => {
  try {
    const userInfo = await API.reqUserInfo();

    if (!userInfo) {
      console.error('No user info returned!');
      return;
    }

    const additionalUserInfo =
      (userInfo &&
        (await API.queryMemberInfoByGuid(userInfo.uid))?.members.find(
          (m) => m.guid === userInfo.uid,
        )) ||
      {};

    const userInfoInStorage = JSON.parse(window.localStorage.userInfo || '{}');
    const mergedUserInfo = Object.assign({}, userInfoInStorage, userInfo);

    const enhancedUserInfo = {
      ...userInfo,
      ...mergedUserInfo,
      ...additionalUserInfo,
      guid: userInfo.uid,
      role: getUserRole(userInfo),
    };

    window.Storage.setItem('userInfo', JSON.stringify(enhancedUserInfo));

    dispatch(loginActions.updateUserInfo(enhancedUserInfo));

    window.SessionStorage.removeItem('loginProgress');
  } catch (error) {
    console.error('=== getUserInfo ERROR ===');
    console.error('Error:', error);
    throw error;
  }
};

export default {
  ...loginActions,
  login,
  logout,
  register,
  fetchUserDetails,
  getLogin,
  getTermsAcceptance,
  getNewTermsAcceptance,
  getUserInfo,
};
